import { render, staticRenderFns } from "./identity-verification-header.vue?vue&type=template&id=2d02e023&"
import script from "./identity-verification-header.vue?vue&type=script&lang=ts&"
export * from "./identity-verification-header.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports